import http from '@/http/aisea/axios'
const resource = "/enterprises/crews/roles";

export default {

  search() {
    return http.get(`${resource}`);
  },

};
